(function () {
  function init(root) {
    if (!root || root.dataset.vxmInit) return;
    root.dataset.vxmInit = '1';

    let video = root.querySelector('.vxm__media');
    let motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let narrow = window.matchMedia('(max-width: 767px)');

    function motionBlocked() {
      return motion.matches;
    }

    function currentSrc() {
      if (!video) return '';
      let mobileSrc = video.getAttribute('data-src-m') || '';
      let desktopSrc = video.getAttribute('data-src-d') || '';
      if (narrow.matches && mobileSrc) return mobileSrc;
      return desktopSrc || mobileSrc;
    }

    function activate() {
      if (!video || motionBlocked()) return;
      let next = currentSrc();
      if (!next) return;
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;
      if (video.getAttribute('data-loaded') !== next) {
        video.setAttribute('data-loaded', next);
        video.src = next;
      }
      let playPromise = video.play();
      if (playPromise && playPromise.catch) playPromise.catch(function () {});
    }

    function deactivate() {
      if (!video) return;
      video.pause();
    }

    root.addEventListener('click', function (event) {
      let link = event.target && event.target.closest ? event.target.closest('a[href^="#"]') : null;
      if (!link || !root.contains(link)) return;
      let href = link.getAttribute('href');
      if (!href || href === '#') return;
      let id = decodeURIComponent(href.slice(1));
      let target = id && document.getElementById(id);
      if (!target) return;
      event.preventDefault();
      let top = target.getBoundingClientRect().top + window.pageYOffset - 104;
      window.scrollTo({
        top: top < 0 ? 0 : top,
        behavior: motion.matches ? 'auto' : 'smooth'
      });
      if (window.history && history.pushState) history.pushState(null, '', '#' + id);
    });

    if (!video) return;

    function onMq() {
      if (!video.getAttribute('src') || motionBlocked()) return;
      activate();
    }

    if (narrow.addEventListener) narrow.addEventListener('change', onMq);
    else if (narrow.addListener) narrow.addListener(onMq);

    function onMotion() {
      if (motionBlocked()) {
        video.removeAttribute('src');
        video.removeAttribute('data-loaded');
        video.pause();
        return;
      }
      if (root.getAttribute('data-vxm-seen') === '1') activate();
    }

    if (motion.addEventListener) motion.addEventListener('change', onMotion);
    else if (motion.addListener) motion.addListener(onMotion);

    if (motionBlocked()) return;

    if (!('IntersectionObserver' in window)) {
      root.setAttribute('data-vxm-seen', '1');
      activate();
      return;
    }

    new IntersectionObserver(
      function (entries) {
        let entry = entries[0];
        if (!entry) return;
        if (entry.isIntersecting) {
          root.setAttribute('data-vxm-seen', '1');
          activate();
        } else {
          deactivate();
        }
      },
      { rootMargin: '200px' }
    ).observe(root);
  }

  function boot(scope) {
    let roots = (scope || document).querySelectorAll('[data-vxm]');
    for (let i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    let section = event.target;
    if (!section || !section.querySelector) return;
    let root = section.querySelector('[data-vxm]');
    if (!root) return;
    delete root.dataset.vxmInit;
    init(root);
  });
})();
